import React, { useState } from 'react';

export default function Quiz({
  question,
  options,
  correctAnswer,
  explanation,
  onAnswer,
  disabled = false,
  showResult = false,
  userAnswer = null
}) {
  // Convert from 1-based (DB) to 0-based (frontend)
  const correctIndex = correctAnswer !== undefined && correctAnswer !== null
    ? correctAnswer - 1
    : 0;

  // Use the userAnswer as initial state if in review mode
  const initialSelected = (userAnswer !== null && userAnswer !== undefined && disabled) 
    ? userAnswer 
    : null;
  
  const [selected, setSelected] = useState(initialSelected);
  const [revealed, setRevealed] = useState(initialSelected !== null);

  const handleSelect = (index) => {
    if (disabled || revealed) return;
    setSelected(index);
    onAnswer(index, index === correctIndex);
    setRevealed(true);
  };

  const getOptionClass = (index) => {
    if (!revealed) {
      return selected === index ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-gray-300';
    }
    if (index === correctIndex) {
      return 'border-green-500 bg-green-50';
    }
    if (selected === index && selected !== correctIndex) {
      return 'border-red-500 bg-red-50';
    }
    return 'border-gray-200 opacity-60';
  };

  const getOptionIcon = (index) => {
    if (!revealed) return null;
    if (index === correctIndex) return '✅';
    if (selected === index && selected !== correctIndex) return '❌';
    return null;
  };

  return (
    <div className="my-4">
      {disabled && userAnswer !== null && revealed && (
        <div className="mb-3 p-2 bg-blue-50 border border-blue-200 rounded-lg text-xs text-blue-700">
          🔒 Review Mode: Your previous answer is shown below.
        </div>
      )}
      <h3 className="font-medium mb-3 text-lg">{question}</h3>
      <div className="space-y-2">
        {options && options.map((option, idx) => (
          <button
            key={idx}
            onClick={() => handleSelect(idx)}
            disabled={disabled || revealed}
            className={`w-full text-left p-3 border rounded-lg transition flex items-center justify-between ${
              getOptionClass(idx)
            } ${(disabled || revealed) ? 'cursor-default' : 'cursor-pointer hover:bg-gray-50'}`}
          >
            <span>{option}</span>
            <span className="text-xl">{getOptionIcon(idx)}</span>
          </button>
        ))}
      </div>
      {revealed && explanation && selected !== null && (
        <div className={`mt-3 p-3 rounded-lg ${
          selected === correctIndex
            ? 'bg-green-50 border border-green-200'
            : 'bg-red-50 border border-red-200'
        }`}>
          <p className="text-sm font-medium">
            {selected === correctIndex ? '✅ Correct!' : '❌ Incorrect'}
          </p>
          <p className="text-sm text-gray-600 mt-1">{explanation}</p>
          {disabled && userAnswer !== null && selected !== correctIndex && (
            <div className="mt-2 text-sm border-t pt-2">
              <p className="text-gray-600">
                <span className="font-medium">Your answer:</span> {options[userAnswer] || 'Not answered'}
              </p>
              <p className="text-green-600">
                <span className="font-medium">Correct answer:</span> {options[correctIndex]}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
